import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { PageLayout } from 'components/PageLayout';
import { TestNotificationsContent } from './TestNotificationsContent';

const Content = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('testNotifications.title')}</title>
      </Helmet>
      <TestNotificationsContent />
    </>
  );
};

export const TestNotifications = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <PageLayout
      headerBarProps={{ action: 'back', title: t('testNotifications.title') }}
    >
      <Content />
    </PageLayout>
  );
};
